import { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import "../assets/css/login.css";
import Swal from "sweetalert2";

const LoginPage = () => {
    const navigate = useNavigate();
    const [showResend, setShowResend] = useState(false);
    const [resendMsg, setResendMsg] = useState("");


    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });

    const [errors, setErrors] = useState({
        email: "",
        password: ""
    });

    const [showPassword, setShowPassword] = useState(false);

    // Input Change
    const handleChange = (e) => {
         if (errors[e.target.name]) {
        setErrors({
            ...errors,
            [e.target.name]: ""
        });
    }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Validation
    const validateLogin = () => {
        let newErrors = {};

        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Enter a valid email";
        }

        if (!formData.password.trim()) {
            newErrors.password = "Password is required";
        } else if (formData.password.length < 6) {
            newErrors.password = "Password must be at least 8 characters";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Login Handler
    const handleLogin = async (e) => {
        e.preventDefault();
        if (!validateLogin()) return;

        try {
            const res = await fetch("https://kalakakshaaha.com/kks/api/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: formData.email,
                    password: formData.password
                })
            });

            const data = await res.json();

            if (!data.success) {
                // EMAIL NOT VERIFIED
    if (data.resend_allowed) {
        setErrors({ password: data.message });
        setShowResend(true);
        return;
    }
                let newErrors = {};

                if (data.message.toLowerCase().includes("password")) {
                    newErrors.password = "Incorrect password";
                } else if (data.message.toLowerCase().includes("email")) {
                    newErrors.email = "Email not found";
                } else {
                    // newErrors.password = "Invalid login credentials";
                            newErrors.password = data.message;

                }

                // setErrors(newErrors);
                //    setErrors({ password: data.message });
                 setErrors(newErrors);
    setShowResend(false);

                return;
            }

            // SUCCESS → Save token
            localStorage.setItem("token", data.token);
            // alert("Login Successful")
            // console.log(data.token)
            // SUCCESS → Save token

// 🔥 SweetAlert popup
Swal.fire({
  icon: "success",
  title: "Login Successful",
  width: 380,
  heightAuto: false,
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  allowOutsideClick: false,
  allowEscapeKey: false,
  didClose: () => {
    if (data.role === "student") {
      navigate("/student-profile");
    } else if (data.role === "tutor") {
      navigate("/tutor-profile");
    } else {
      Swal.fire({
        icon: "error",
        title: "Unknown User Type",
        text: "Please contact support"
      });
    }
  }
});


            // IMPORTANT: Backend must return data.role = "student" / "tutor"
            // if (data.role === "student") {
            //     navigate("/student-profile");
            // } else if (data.role === "tutor") {
            //     navigate("/tutor-profile");
            // } else {
            //     alert("Unknown user type");
            // }

        } catch (error) {
            console.log("Login Error:", error);
            // alert("Unable to login. Check your API server.");
            Swal.fire({
  icon: "error",
  title: "Login Failed",
  text: "Unable to login. Please try again later.",
  width: 380,
  heightAuto: false
});

        }
    };
const resendVerification = async () => {
    try {
        const res = await fetch(
            "https://kalakakshaaha.com/kks/api/v1/resend-verification",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: formData.email })
            }
        );

        const data = await res.json();

        if (data.success) {
            setResendMsg("Verification link sent to your email.");
        } else {
            setResendMsg(data.message);
        }
    } catch (err) {
        setResendMsg("Unable to resend verification email.");
    }
};

    return (
        <Fragment>
            <Header />

            <div className="login-wrapper fadeIn" >
                <div className="login-card" >

                    <h3 className="login-title">Welcome Back</h3>

                    {/* --- REMOVED DROPDOWN --- */}

                    <form className="mt-3" onSubmit={handleLogin}>
                        <input
                            type="email"
                            name="email"
                            placeholder="Email *"
                            className="login-input"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                        <p className={`validation-msg ${errors.email ? "show" : ""}`}>
                            {errors.email}
                        </p>
           <div className={`input-wrapper ${errors.password ? "error-active" : ""}`}>

                        <div className="password-box">
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                placeholder="Password *"
                                className="login-input"
                                value={formData.password}
                                onChange={handleChange}
                            />
                           <i
        className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"} eye-icon`}
        onClick={() => setShowPassword(!showPassword)}
    ></i>
                        </div>

                        <p className={`validation-msg ${errors.password ? "show" : ""}`}>
                            {errors.password}
                        </p>
                        {showResend && (
    <div style={{ marginTop: "10px", textAlign: "center" }}>
        <button
            type="button"
            onClick={resendVerification}
            style={{
                background: "none",
                border: "none",
                color: "#007bff",
                cursor: "pointer",
                fontWeight: "600"
            }}
        >
            Resend Verification Link
        </button>

        {resendMsg && (
            <p style={{ color: "green", marginTop: "5px", fontSize: "14px" }}>
                {resendMsg}
            </p>
        )}
    </div>
)}

                        </div>

                        <button className="login-btn">Login</button>
                    </form>

                   <div className="login-bottom">
                       Don't have an account?
  <p>
 
    <Link to="/tutor/signup" className="link tutor-link">
      Tutor Signup
    </Link>
     <span className="divider">|</span>
     <Link to="/signup" className="link student-link">
      Student Signup
    </Link>
  </p>

  <div className="login-links">
   
   
    <Link to="/forget-password" className="link forgot-link">
      Forgot Password?
    </Link>
  </div>
</div>


                </div>
            </div>
            <Footer/>

        </Fragment>
    );
};

export default LoginPage;
